<template>
	<b-container class="mh-100 m-0 p-0">
		<template v-if="sandbox">
<!-- 
			<transition-group key="transition.sandbox" name="fade" appear>
 -->
				<b-row key="sandbox.header" no-gutters>
					<b-col class="border-bottom border-1 p-2">
						<b-row class="align-items-center" no-gutters>
							<b-col>
								<h5 class="m-auto font-weight-bold">{{ enrollment.courseId || sandbox.course }} / {{ sandbox.label || sandbox.name }}</h5>
							</b-col>
							<b-col>
								<b-row no-gutters>
									<b-col class="px-2">
										<b-button id="button.provision" variant="dark" size="sm" class="btn-round" block @click="doProvision($event);" :disabled="isProvisioned || isMacOnly">Provision</b-button>
									</b-col>
									<b-col class="px-2">
										<b-button id="button.poweron" variant="dark" size="sm" class="btn-round" block @click="doStartNodes($event);" :disabled="!isProvisioned || isRunning">Power On</b-button>
									</b-col>
									<b-col class="px-2">
										<b-button id="button.reboot" variant="dark" size="sm" class="btn-round" block @click="confirmReboot($event);" :disabled="!isProvisioned || !isRunning">Reboot</b-button>
									</b-col>
									<b-col class="px-2">
										<b-button id="button.reset" variant="dark" size="sm" class="btn-round" block @click="confirmDestroy($event);" :disabled="!isProvisioned || isMacOnly">Reset</b-button>
									</b-col>
									<b-col class="px-2">
										<b-button id="button.toggleTooltips" variant="dark" size="sm" class="btn-circle" :class="((shouldShowTooltips) ? 'btn-dark-active' : '')" v-b-tooltip.hover title="Toggle ToolTips" @click="toggleTooltips();"><font-awesome-icon icon="question" /></b-button>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
				<b-row key="sandbox.nodes" no-gutters>
					<b-col class="pt-3">
						<transition-group key="transition.sandbox" name="fade" appear>
							<b-alert show variant="info" key="alert.poweredoff" v-if="!isProvisioned && !isMacOnly">Your sandbox environment has not been provisioned yet. Click <strong>Provision</strong> in the toolbar above to start.</b-alert>
							<b-alert show variant="info" key="alert.poweredoff" v-if="isProvisioned && !isRunning">Some of your machines are powered off. Click <strong>Power On</strong> in the toolbar above to turn them on.</b-alert>
							<b-alert show variant="warning" key="alert.macos" v-if="hasMacNodes">Some self-service functions are not available for macOS instances at this time.</b-alert>
							<Node :node="node" :key="sandbox.uuid + '-' + node.nodename" v-for="node in sandbox.nodes" v-if="node.nodename" />
							<span v-else>No Machines</span>
						</transition-group>
					</b-col>
				</b-row>
				<b-tooltip v-for="key in Object.keys(tooltips)" :key="'tooltip.' + key" :target="key" triggers="hover" :disabled="!shouldShowTooltips">{{ tooltips[key] }}</b-tooltip>
<!-- 
			</transition-group>
 -->
		</template>
		<b-row class="mh-100 align-items-center" style="min-height: 100%;" no-gutters v-else>
			<b-col>
<!-- 
				<transition key="transition.sandbox" name="fade" appear>
 -->
					<elumin-loader />
<!-- 
				</transition>
 -->
			</b-col>
		</b-row>
		<ConfirmModal :ref="confirmModalData.id" :modalData="confirmModalData" @confirmed="confirmModalData.confirmed($event);" />
		<ProcessingModal ref="processingModal" id="processingModal" :visible="shouldShowProcessingModal" :message="modalMessage" />
	</b-container>
</template>

<script>
	import Node from '@/components/Sandbox/Node';
	
	import tooltips from '@/components/Sandbox/tooltips.json';
	
	import { mapState } from 'vuex';
	
	let listeners = [];
	
	export default
	{
		name: 'sandbox',
		components: { Node },
		computed:
		{
			...mapState([ 'shouldShowTooltips' ]),
			
			shouldShowProcessingModal: function()
			{
				if(this.isProcessing)
					return this.isProcessing;
				
				if(this.isStateChanging)
				{
					this.modalMessage = 'Please wait while your <strong>' + this.sandbox.course + ' - ' + (this.sandbox.label || this.sandbox.name) + '</strong> nodes are completing a power state change.';
					
					return this.isStateChanging;
				}
				
				return false;
			},
			isProvisioned: function()
			{
				if(!this.sandbox || !('nodes' in this.sandbox))
					return false;
				
				return this.sandbox.nodes
					.filter(
						(n) => (!('type' in n) || (/^(vm|aws:ec2|macstadium:orka:vm|veertu:anka:vm)$/.test(n.type)))
					)
					.every(
						(n) => ('ip' in n) && n.ip && ('state' in n) && n.state
					);
			},
			isRunning: function()
			{
				if(!this.sandbox || !('nodes' in this.sandbox))
					return false;
				
				return this.sandbox.nodes
					.filter(
						(n) => (!('type' in n) || (/^(vm|aws:ec2|macstadium:orka:vm|veertu:anka:vm)$/.test(n.type)))
					)
					.every(
						(n) => ('state' in n) && n.state == 'running'
					);
			},
			isStateChanging: function()
			{
				if(!this.sandbox || !('nodes' in this.sandbox))
					return false;
				
				return this.sandbox.nodes.some(
					(n) => this.isNodeStateChanging(n.state)
				);
			},
			hasMacNodes: function()
			{
				if(!this.sandbox || !('nodes' in this.sandbox))
					return false;
				
				return this.sandbox.nodes.findIndex((n) => (('type' in n) && (/^(macstadium:orka:vm|veertu:anka:vm)$/.test(n.type)))) !== -1;
			},
			isMacOnly: function()
			{
				if(!this.sandbox || !('nodes' in this.sandbox))
					return false;
				
				return this.sandbox.nodes.every((n) => (('type' in n) && (/^(macstadium:orka:vm|veertu:anka:vm)$/.test(n.type))));
			},
			enrollment: function()
			{
				return this.$parent.enrollments.find((e) => e.uuid === this.$route.params.enrollmentUUID);
			}
		},
		asyncComputed:
		{
			sandbox:
			{
				lazy: true,
				default () { return undefined },
				get()
				{
					if(!this.$route.params.sandboxUUID)
						return undefined;
					
					console.debug('Fetching data: sandboxes');
					
					return fetch(
						this.$root.$refs.app.apiURL + '/sandbox/' + this.$route.params.sandboxUUID,
						{
							method: 'get',
							headers: { 'Content-type': 'application/json' },
							credentials: 'include'
						}
					).then(
						(res) => res.json(),
						(err) => this.showError(err)
					);
				}
			}
		},
		methods:
		{
			toggleTooltips: function(v) { this.$root.$refs.app.toggleTooltips(v) },
			isNodeStateChanging: function(state)
			{
				if(!state)
					return false;
				
				return !(['stopped', 'suspended', 'running'].includes(state));
			},
			doProvision: async function(e)
			{
				let vm = this;

				vm.modalMessage = 'Please wait while the resources for your <strong>' + vm.sandbox.course + ' - ' + (vm.sandbox.label || vm.sandbox.name) + '</strong> environment are being assigned.';
				vm.isProcessing = true;
				
				let result = await fetch(
					vm.$root.$refs.app.apiURL + '/sandbox/' + this.$route.params.sandboxUUID + '/allocate',
					{ method: 'post', credentials: 'include' }
				).then(
					(res) => res.json(),
					(err) => this.showError(err)
				).then(
					(data) => data
				);
				
				if(result !== undefined)
				{
					setTimeout(
						() =>
						{
							vm.$asyncComputed.sandbox.update();
						
							vm.isProcessing = false;
						},
						1000 * ((result === false) ? 1 : 2.5)
					);
				}
			},
			doStartNodes: async function(e)
			{
				let vm = this;
				
				vm.modalMessage = 'Please wait while your <strong>' + vm.sandbox.course + ' - ' + (vm.sandbox.label || vm.sandbox.name) + '</strong> nodes are being started.';
				vm.isProcessing = true;
				
				let result = await fetch(
					vm.$root.$refs.app.apiURL + '/sandbox/' + this.$route.params.sandboxUUID + '/start',
					{ method: 'post', credentials: 'include' }
				).then(
					(res) =>
					{
						if(!/^2\d\d$/.test(res.status))
							return this.showError(new Error('Start request failed!'));
						
						return true;
					},
					(err) => this.showError(err)
				);
				
				if(result !== undefined)
				{
					setTimeout(
						() =>
						{
							vm.$asyncComputed.sandbox.update();
						
							vm.isProcessing = false;
						},
						1000 * ((result === false) ? 1 : 10)
					);
				}
			},
			confirmReboot: function(e)
			{
				let sandbox = this.sandbox;
				let data = this.confirmModalData;
				
				data.label = 'Reboot ' + (sandbox.label || sandbox.name);
				data.confirmText = sandbox.name;
				data.confirmButtonText = 'Reboot';
				data.message = 'Any unsaved data will on the "' + (sandbox.label || sandbox.name) + '" nodes will be lost.';
				data.confirmed = this.doRebootNodes;
				
				this.$root.$emit('bv::show::modal', data.id);
			},
			doRebootNodes: async function(e)
			{
				let vm = this;
				
				vm.modalMessage = 'Please wait while your <strong>' + vm.sandbox.course + ' - ' + (vm.sandbox.label || vm.sandbox.name) + '</strong> nodes are being rebooted.';
				vm.isProcessing = true;
				
				let result = await fetch(
					vm.$root.$refs.app.apiURL + '/sandbox/' + this.$route.params.sandboxUUID + '/reboot',
					{ method: 'post', credentials: 'include' }
				).then(
					(res) =>
					{
						if(!/^2\d\d$/.test(res.status))
							return this.showError(new Error('Reboot request failed!'));
						
						return true;
					},
					(err) => this.showError(err)
				);
				
				if(result !== undefined)
				{
					setTimeout(
						() =>
						{
							vm.$asyncComputed.sandbox.update();
						
							vm.isProcessing = false;
						},
						1000 * ((result === false) ? 1 : 10)
					);
				}
			},
			confirmDestroy: function(e)
			{
				let sandbox = this.sandbox;
				let data = this.confirmModalData;
				
				data.label = 'Reset ' + (sandbox.label || sandbox.name);
				data.confirmText = sandbox.name;
				data.confirmButtonText = 'Destroy';
				data.message = 'Resetting your "' + (sandbox.label || sandbox.name) + '" sandbox will erase all files you may have stored within the sandbox nodes. This action can not be undone.';
				data.confirmed = this.doDestroy;
				
				this.$root.$emit('bv::show::modal', data.id);
			},
			doDestroy: async function(e)
			{
				let vm = this;
				
				vm.modalMessage = 'Please wait while we reset your <strong>' + vm.sandbox.course + ' - ' + (vm.sandbox.label || vm.sandbox.name) + '</strong> sandbox.';
				vm.isProcessing = true;
				
				let result = await fetch(
					vm.$root.$refs.app.apiURL + '/sandbox/' + this.$route.params.sandboxUUID + '/destroy',
					{ method: 'delete', credentials: 'include' }
				).then(
					(res) =>
					{
						if(!/^2\d\d$/.test(res.status))
							return this.showError(new Error('Reset request failed!'));
						
						return true;
					},
					(err) => this.showError(err)
				);
				
				if(result !== undefined)
				{
					setTimeout(
						() =>
						{
							vm.$asyncComputed.sandbox.update();
						
							vm.isProcessing = false;
						},
						1000 * ((result === false) ? 1 : 10)
					);
				}
			},
			showError: function (message) { return this.$root.$refs.app.showError(message); }
		},
		timers:
		{
			refreshSandboxData:
			{
				callback: function() { this.$asyncComputed.sandbox.update(); },
				autostart: false,
				repeat: true,
				immediate: false,
				time: 1000 * 120
			}
		},
		mounted()
		{
			let vm = this;
			
			vm.$watch(
				'isStateChanging',
				{
					handler: function(nVal, oVal)
					{
						if(nVal)
						{
							console.debug('Changing timer refreshSandboxData to 30s');
							
							vm.timers.refreshSandboxData.immediate = true;
							vm.timers.refreshSandboxData.time = 1000 * 30;
						}
						else
						{
							console.debug('Changing timer refreshSandboxData to 120s');
							
							vm.timers.refreshSandboxData.immediate = false;
							vm.timers.refreshSandboxData.time = 1000 * 120;
						}
						
						vm.$timer.stop('refreshSandboxData');
						vm.$timer.start('refreshSandboxData');
						
						return nVal;
					},
					immediate: true
				}
			);
		},
		beforeDestroy()
		{
			listeners.forEach(
				(v) =>
				{
					console.debug('Deregistering listener: ' + v);
					
					this.$root.$off(v);
				}
			);
		},
		data()
		{
			return {
				tooltips: tooltips[this.$options.name],
				isProcessing: false,
				modalMessage: undefined,
				confirmModalData:
				{
					id: 'confirmModal',
					message: undefined,
					confirmText: undefined,
					confirmed: () => this.showError('Confirm action not defined')
				},
				errorModalData:
				{
					id: 'errorModal',
					message: undefined,
				}
			};
		}
	}
</script>

<style scoped>
	.container
	{
		min-height: 100%;
	}
	
	.btn-round
	{
		height: 30px;
		border-radius: 2em;
	}
	
	.btn-circle
	{
		width: 30px;
		height: 30px;
		border-radius: 2em;
	}
	
	.fade-enter-active, .fade-leave-active
	{
		transition: all 0.25s;
	}
	
	.fade-enter, .fade-leave-to
	{
		opacity: 0;
	}
</style>
